/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetFollowingQueryResponse,
  GetFollowing401,
} from "../types/GetFollowing.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { getFollowing } from "../client/getFollowing.ts"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getFollowingQueryKey = () => [{ url: "/following" }] as const

export type GetFollowingQueryKey = ReturnType<typeof getFollowingQueryKey>

export function getFollowingQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getFollowingQueryKey()
  return queryOptions<
    GetFollowingQueryResponse,
    ResponseErrorConfig<GetFollowing401>,
    GetFollowingQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getFollowing(config)
    },
  })
}

/**
 * @summary Get encrypted profile data for all users you follow
 * {@link /following}
 */
export function useGetFollowing<
  TData = GetFollowingQueryResponse,
  TQueryData = GetFollowingQueryResponse,
  TQueryKey extends QueryKey = GetFollowingQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetFollowingQueryResponse,
        ResponseErrorConfig<GetFollowing401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getFollowingQueryKey()

  const query = useQuery(
    {
      ...getFollowingQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetFollowing401>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
